function getNodeEnv(): 'production' | 'development' {
  try {
    return process.env.NODE_ENV as any;
  } catch (e) {
    console.error('获取环境变量失败', e);
    return 'production';
  }
}

const isProd = getNodeEnv() === 'production';
const isDev = getNodeEnv() === 'development';

function getDevPort() {
  let port = '';
  try {
    port = process.env.PORT || '';
  } catch (e) {
    if (!isProd) {
      console.error('获取本地端口失败', e);
    }
  }
  return port;
}

const awsRumConfig = {
  identityPoolId: process.env.WEB_AWS_RUM_IDENTITY_POOL_ID || '',
  applicationId: process.env.WEB_AWS_RUM_APPLICATION_ID || '',
};

export {
  isProd,
  getNodeEnv,
  getDevPort,
  isDev,
  awsRumConfig,
};